import { render, staticRenderFns } from "./driver_review_page.vue?vue&type=template&id=9cb67004&scoped=true"
import script from "./driver_review_page.vue?vue&type=script&lang=js"
export * from "./driver_review_page.vue?vue&type=script&lang=js"
import style0 from "./driver_review_page.vue?vue&type=style&index=0&id=9cb67004&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb67004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cb67004')) {
      api.createRecord('9cb67004', component.options)
    } else {
      api.reload('9cb67004', component.options)
    }
    module.hot.accept("./driver_review_page.vue?vue&type=template&id=9cb67004&scoped=true", function () {
      api.rerender('9cb67004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/driver/driver_review_page.vue"
export default component.exports